__webpack_require__.p = "/energy/paper/Visualization_of_Landuse/";